import React from 'react';
import clsx from 'clsx';
import styles from './FloatingToggleButton.module.scss';

export default function FloatingToggleButton({
	show = true,
	enabled,
	icon,
	textOnShow,
	onClick,
	right,
	top,
	className: classNameProps
}) {
	const inlineStyle = { right: right, top: top };

	return show ? (
		<button
			className={clsx(
				styles.root,
				enabled ? styles.enabled : styles.disabled,
				classNameProps
			)}
			onClick={onClick}
			style={inlineStyle}
		>
			{enabled ? '' : textOnShow} {icon}
		</button>
	) : null;
}
